import { ActionType } from '../actionTypes';
import { Action } from '../actions/changeFlyerDetailsActions';
import { Dispatch } from 'redux';

export const someFlyerDetailsDataWasChangedInFlyerDetailsPopup = (isChanged: boolean) => {
    return async (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.FLYER_DETAILS_ANY_DATA_WAS_CHANGED,
            payload: isChanged
        });
    }
}